// Need to load bootstrap file in this manner as it's the only way the chunks for module federation load properly.

if (window.NUCONFIG) {
    __webpack_public_path__ = (window.NUCONFIG.assetPath || "") + "/"; // eslint-disable-line
}

import("./bootstrap.js");
